import type { RaffleStatus } from '../api/types';

export interface RaffleStatusMeta {
  label: string;
  pill: '' | 'green' | 'yellow' | 'red' | 'indigo';
}

/** The design prototype had four statuses (posted/scraped/pending/expired).
 *  Only three ever occur: a re-encountered link updates its existing row rather
 *  than creating a new one, so nothing sits in a "scraped but not posted"
 *  state. `duplicate` is included for completeness but is not a resting state. */
export const RAFFLE_STATUS: Record<RaffleStatus, RaffleStatusMeta> = {
  posted: { label: 'Posted', pill: 'green' },
  expired: { label: 'Expired', pill: '' },
  failed: { label: 'Failed', pill: 'red' },
  duplicate: { label: 'Duplicate', pill: 'indigo' },
};

/** Chips shown above the Raffles table, in display order. */
export const RAFFLE_FILTERS: Array<{ value: string; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'posted', label: 'Posted' },
  { value: 'expired', label: 'Expired' },
  { value: 'failed', label: 'Failed' },
];

export function statusMeta(status: RaffleStatus): RaffleStatusMeta {
  return RAFFLE_STATUS[status] ?? { label: status, pill: '' };
}
